var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_setup.hasChildren || _setup.visibleChildren.length
    ? _c(
        "div",
        { staticClass: "menu-item", class: { collapsed: _vm.collapsed } },
        [
          _c(
            _setup.isLink ? "a" : "button",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: {
                    content: _vm.item.name,
                    placement: "right",
                    boundary: "window",
                    onShow: () => _vm.collapsed,
                  },
                  expression:
                    "{ content: item.name, placement: 'right', boundary: 'window', onShow: () => collapsed }",
                },
              ],
              tag: "component",
              staticClass: "section-item",
              class: {
                expanded: _setup.hasChildren && _vm.expanded,
                active:
                  !_setup.hasChildren &&
                  _vm.item.route?.length &&
                  _vm.item.route == _vm.activeRoute,
              },
              attrs: {
                type: _setup.isLink ? undefined : "button",
                href: _setup.isLink ? _setup.getHref(_vm.item) : undefined,
                target: _setup.isExternal(_vm.item) ? "_blank" : undefined,
                rel: _setup.isExternal(_vm.item)
                  ? "noopener noreferrer"
                  : undefined,
                role: "menuitem",
                "aria-expanded": _setup.hasChildren ? _vm.expanded : undefined,
                "aria-current":
                  !_setup.hasChildren &&
                  _vm.item.route?.length &&
                  _vm.item.route == _vm.activeRoute
                    ? "page"
                    : undefined,
              },
              on: { click: _setup.onItemClick },
            },
            [
              _c(
                "div",
                { staticClass: "icon-container" },
                [_c("font-awesome-icon", { attrs: { icon: _vm.item.icon } })],
                1
              ),
              _vm._v(" "),
              !_vm.collapsed
                ? _c("span", [_vm._v(_vm._s(_vm.item.name))])
                : _vm._e(),
              _vm._v(" "),
              _setup.hasChildren && !_vm.collapsed
                ? _c("font-awesome-icon", {
                    staticClass: "ml-auto chevron",
                    class: { open: _vm.expanded },
                    attrs: { icon: ["far", "chevron-down"] },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _setup.hasChildren && !_vm.collapsed
            ? _c(
                "div",
                { staticClass: "submenu", class: { open: _vm.expanded } },
                [
                  _c(
                    "ul",
                    { staticClass: "submenu-inner" },
                    _vm._l(_setup.visibleChildren, function (child) {
                      return _c(
                        "li",
                        {
                          key: child.name,
                          staticClass: "submenu-item",
                          class: {
                            active:
                              child.route?.length &&
                              child.route == _vm.activeRoute,
                          },
                        },
                        [
                          _c(
                            _setup.getHref(child) ? "a" : "button",
                            {
                              tag: "component",
                              staticClass: "submenu-link",
                              attrs: {
                                type: _setup.getHref(child)
                                  ? undefined
                                  : "button",
                                href: _setup.getHref(child),
                                target: _setup.isExternal(child)
                                  ? "_blank"
                                  : undefined,
                                rel: _setup.isExternal(child)
                                  ? "noopener noreferrer"
                                  : undefined,
                                role: "menuitem",
                                "aria-current":
                                  child.route?.length &&
                                  child.route == _vm.activeRoute
                                    ? "page"
                                    : undefined,
                              },
                              on: {
                                click: function ($event) {
                                  return _setup.handleClick(child, $event)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(child.name) +
                                  "\n                "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }